module.exports = __webpack_public_path__ + "static/media/backimage_1.e3788808.jpeg";